import React from 'react';
import { Image, StyleSheet } from 'react-native';
// import { SvgXml } from 'react-native-svg';

import { ViewPropTypes, ImagePropTypes } from 'deprecated-react-native-prop-types';
import memoize from 'memoize-one';
import PropTypes from 'prop-types';

import AnimationView from '../AnimationView';

import IconTypes, { IconTypesValues } from './IconTypes';

const determineProperIconTag = (iconType, src) => {
  switch (iconType) {
    case IconTypes.animatedImage:
      return AnimationView;
    // case IconTypes.svgImage:
    //   return SvgXml;
    case IconTypes.image:
    default:
      return Image;
  }
};

const getProperPropsFormat = (type, name, size, style) => {
  switch (type) {
    case IconTypes.image:
    case IconTypes.animatedImage:
      return {
        source: name,
        style: StyleSheet.flatten([{ width: size, height: size }, style]),
      };
    case IconTypes.svgImage:
      return {
        xml: name?.svg,
        width: size,
        height: size,
        style: style,
      };
    default:
      return {
        name,
        size,
        style,
      };
  }
};

const determineProperIconTagMemoized = memoize(determineProperIconTag);
const getProperPropsFormatMemoized = memoize(getProperPropsFormat);

const getProperType = (type, imageSource) => {
  if (imageSource?.svg) {
    return IconTypes.svgImage;
  }

  if (!type) {
    return IconTypes.image;
  }

  return type;
};

const Icon = ({ type: srcType, name, size, style, ...props }) => {
  const type = getProperType(srcType, name);

  const IconComponent = determineProperIconTagMemoized(type);
  const iconProps = getProperPropsFormatMemoized(type, name, size, style);

  return (
    <IconComponent
      {...iconProps}
      {...props}
      type={type === IconTypes.animatedImage ? 'image' : type}
    />
  );
};

Icon.resolveSVGSource = svgContent => {
  return {
    svg: svgContent,
  };
};

Icon.defaultProps = {
  size: 25,
  style: {},
};

const ImageSourceType = PropTypes.oneOfType([
  PropTypes.shape({ svg: PropTypes.string }),
  PropTypes.shape({ uri: PropTypes.string }),
]);

Icon.propTypes = {
  name: ImageSourceType,
  type: PropTypes.oneOf(IconTypesValues),
  size: PropTypes.number,
  style: PropTypes.oneOfType([ImagePropTypes.style, ViewPropTypes.style]),
};

export default Icon;
